<template>
  <div id="create-user">
    <b-row>
      <b-col
        md="6">
        <b-form-group :class="{'error-input' : $v.data_employee.email.$error}">
          <label> Email <span style="color:red">*</span></label>
          <j-input
            v-model="$v.data_employee.email.$model"
            :max-length="50"
            placeholder="Email"
            type="email"/>
        </b-form-group>
      </b-col>
      <b-col
        md="6">
        <label> Password <span style="color:red">*</span></label>
        <b-form-group
          id="passwordInput"
          :class="{'error-input' : $v.data_employee.password.$error || isNotStrenghtPassword}">
          <j-input
            id="exampleInput2"
            :type="password_id"
            :error-required="$v.data_employee.password.$error"
            :error-message="'Field is required'"
            v-model="$v.data_employee.password.$model"
            placeholder="Password"/>
          <span>
            <i
              :class="{'fa fa-eye': !show_pass, 'fa fa-eye-slash': show_pass,
                       'eye-error' : $v.data_employee.password.$error || isNotStrenghtPassword}"
              @click="show_pass=!show_pass"/>
          </span>
        </b-form-group>
        <PasswordChecker
          ref="passwordChecker"
          :data="data_employee"
          class="my-1" />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="6">
        <b-form-group :class="{'error-input' : $v.data_employee.first_name.$error}">
          <label> First Name <span style="color:red">*</span></label>
          <j-input
            v-model="$v.data_employee.first_name.$model"
            :max-length="50"
            placeholder="First Name"/>
        </b-form-group>
      </b-col>
      <b-col
        md="6">
        <b-form-group>
          <label> Last Name </label>
          <j-input
            v-model="data_employee.last_name"
            :max-length="50"
            placeholder="Last Name"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="6">
        <b-row>
          <b-col
            sm="12"
            md="8">
            <b-form-group :class="{'error-input' : $v.data_employee.age.$error}">
              <label> Date Of Birth <span style="color:red">*</span></label>
              <j-datepicker
                v-model="data_employee.date_of_birth"
                :disabled-dates="disabledBirthdayDate"
                :error-message="ageErrmessage"
                format="MMM dd, yyyy"
                placeholder="Jan 01, 2020"/>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4">
            <b-form-group>
              <label> Age </label>
              <j-input
                v-model="data_employee.age"
                disabled/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        md="6">
        <b-form-group :class="{'error-input' : $v.data_employee.role.$error}">
          <label> Role <span style="color:red">*</span></label>
          <j-single-select
            v-model="data_employee.role"
            :options="roles_option"
            value-format="object"
            placeholder="Select Role"
            label="name"/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// eslint-disable-next-line
import { required, minValue } from 'vuelidate/lib/validators';
import Constant from '@/utils/constant';
import PasswordChecker from '@/views/user-employee/partials/PasswordChecker';

export default {
  components: {
    PasswordChecker,
  },
  validations() {
    const validation = {
      data_employee: {
        id: {

        },
        email: {
          required,
        },
        password: {
          required,
        },
        first_name: {
          required,
        },
        date_of_birth: {
          required,
        },
        age: {
          required,
        },
        role: {
          required,
        },
      // code: {
      //   // required
      // },
      },
    };
    if (this.data_employee.date_of_birth) {
      if (this.data_employee.age < 18) {
        validation.data_employee.age = { minValue: minValue(18) };
      }
    }
    return validation;
  },
  data() {
    return {
      data_employee: {
        id: 0,
        email: null,
        password: null,
        first_name: null,
        last_name: null,
        date_of_birth: '',
        age: null,
        role: null,
        // code: '',
        // is_payroll_user: false,
      },
      disabledBirthdayDate: {
        color: 'white',
        background_color: 'light-grey',
        ranges: [
          {
            from: new Date(),
            to: new Date(9999, 11, 31),
          },
        ],
      },
      show_pass: false,
      roles_option: [
        {
          id: Constant.RoleImplementor,
          name: 'Implementor',
        },
        {
          id: Constant.RoleUser,
          name: 'User',
        },
      ],
      isNotStrenghtPassword: false,
    };
  },
  computed: {
    ageErrmessage() {
      if (!this.$v.data_employee.age.minValue) {
        return 'Age must be greater or equal to 18';
      }
      return 'Field is required';
    },
    password_id() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },
    pwdErrmessage() {
      if (!this.$v.data_employee.password.required) {
        return 'Field is required';
      } else if (!this.$v.data_employee.password.minLength &&
                !this.$v.data_employee.password.notContainAccountName) {
        return 'Minimum length is 5 characters and your password cannot contain your account name';
      } else if (!this.$v.data_employee.password.minLength) {
        return 'Minimum length is 5 characters';
      } else if (!this.$v.data_employee.password.notContainAccountName) {
        return 'Your password cannot contain your account name';
      }
      return 'Field is required';
    },
  },
  watch: {
    // eslint-disable-next-line
    'data_employee.email': function(val) {
      const data = val.replace(/\s/g, '');
      this.data_employee.email = data;
    },

    // eslint-disable-next-line
    'data_employee.date_of_birth': function(val) {
      if (val !== null) {
        const now = new Date();
        let birthday;
        if (typeof val === 'string') {
          birthday = new Date(val);
        } else if (typeof val === 'object') {
          birthday = val;
        }
        const age = now - birthday;
        // eslint-disable-next-line
        this.data_employee.age = parseInt(age / 31556952000);
      }
    },
  },
  methods: {
    save() {
      this.$v.data_employee.$touch();
      this.isNotStrenghtPassword = !this.$refs.passwordChecker.checkPasswordStrengh;
      if (!this.$v.data_employee.$error && !this.isNotStrenghtPassword) {
        this.$emit('data', this.data_employee);
      } else {
        this.$emit('data', null);
      }
    },
  },
};
</script>

<style lang="scss">
  #create-user {
    #passwordInput, #passwordInput > div {
      position: relative;
    }

    #passwordInput > div span {
      position: absolute;
      top: 7px;
      right: 12px;
      font-size: 18px;
      cursor: pointer
    }

    .eye-error {
      margin-right: 20px !important;
    }

    label {
      line-height: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user-employee/detail/jEmployeeForm.vue